import { useGlobalContext } from '../context';
import { Navbar, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import React from 'react';
import { toast } from 'react-toastify';

/*

 <Navbar style={{ marginBottom: '0.5em' }}>
          <Link to="/">
            <Button className="btn-80 " type="primary">
              Home
            </Button>
          </Link>
          <Link to="/learn">
            <Button className="btn-80 " type="primary">
              Learn
            </Button>
          </Link>
          <Link to="/test">
            <Button className="btn-80 " type="primary">
              Test
            </Button>
          </Link>
          {userInfo === {} && (
            <Link to="/login">
              <Button className="btn-80" type="primary">
                Login
              </Button>
            </Link>
          )}
          {userInfo === {} && (
            <Link to="/signup">
              <Button className="btn-80" type="primary">
                Sign Up
              </Button>
            </Link>
          )}
          {userInfo !== {} && (
            <Link to="/">
              <Button
                className="btn-100"
                type="primary"
                style={{ marginInline: '30px' }}
                onClick={signout}
              >
                Sign Out
              </Button>
            </Link>
          )}
        </Navbar>


*/

const MyNavbar = () => {
  const { userInfo, setUserInfo, setScore, score, lessonState, setData } =
    useGlobalContext();

  const [clickedButton, setClickedButton] = React.useState('home');

  const signout = async (e) => {
    e.preventDefault();

    try {
      await axios.patch(
        `https://jap-vocab-n2.herokuapp.com/api/v1/users/${userInfo._id}`,
        {
          score: score,
          lessons: lessonState,
        }
      );
    } catch (err) {
      toast.error(err.message);
    }

    setUserInfo(null);

    setScore(0);
    localStorage.clear();
  };

  const handleClickedButtons = (e, btnId) => {
    setData(null);
    setClickedButton(btnId);
  };

  return (
    <Navbar
      className="flex"
      expand="xxl"
      expanded
      style={{
        marginBottom: '0.5em',
        justifyItems: 'stretch',
      }}
    >
      <Link to="/">
        <Button
          id="home"
          className="btn-80  "
          variant={clickedButton === 'home' ? 'primary' : 'info'}
          onClick={(e) => handleClickedButtons(e, 'home')}
        >
          Home
        </Button>
      </Link>
      <Link to="/learn">
        <Button
          id="learn"
          className="btn-80 "
          variant={clickedButton === 'learn' ? 'primary' : 'info'}
          onClick={(e) => handleClickedButtons(e, 'learn')}
        >
          Learn
        </Button>
      </Link>
      <Link to="/test">
        <Button
          id="test"
          className="btn-80 "
          variant={clickedButton === 'test' ? 'primary' : 'info'}
          onClick={(e) => handleClickedButtons(e, 'test')}
        >
          Test
        </Button>
      </Link>
      {!userInfo && (
        <Link to="/login">
          <Button className="btn-80" type="primary">
            Login
          </Button>
        </Link>
      )}

      {userInfo && (
        <Link to="/">
          <Button
            className="btn-100"
            type="primary"
            style={{ marginInline: '30px' }}
            onClick={signout}
          >
            Sign Out
          </Button>
        </Link>
      )}
    </Navbar>
  );
};

export default MyNavbar;
